/* Project Import will be here */
import { post, IRequest } from "../index";
/* Project Import will be here */

/* Get the survey to list in the survey list page */
export const getSurveyListApi = (data) => {
    const request: IRequest = { subUrl: `/Survey/GetSurveyList`, data };
    return post(request);
};

/* Get the survey details */
export const getSurveyDetailsApi = (data) => {
    const request: IRequest = { subUrl: `/Survey/GetSurveyDetails`, data };
    return post(request);
};

/* Submit survey */
export const submitSurveyApi = (data) => {
    const request: IRequest = { subUrl: `/Survey/SubmitSurvey`, data };
    return post(request);
};

/* Survey Notification */
export const getSurveyNotificationApi = () => {
    const request: IRequest = {
        subUrl: `/Survey/GetSurveyNotification`
    };
    return post(request);
};